import { Download, LogOut, CalendarPlus } from "lucide-react";
import { NotificationBell } from "../NotificationBell";

export const AdminToolbar = ({ leadCount, onLogBooking, onExport, onLogout }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
    <div>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">Lead Dashboard</h1>
      <p className="text-zinc-500 text-sm mt-1">{leadCount} lead{leadCount !== 1 && "s"} shown</p>
    </div>
    <div className="flex gap-3 flex-wrap items-center">
      <NotificationBell />
      <button
        data-testid="log-booking-button"
        onClick={onLogBooking}
        className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-5 py-2.5 text-sm font-semibold transition-colors"
      >
        <CalendarPlus className="h-4 w-4" /> Log Calendar Booking
      </button>
      <button
        data-testid="export-csv-button"
        onClick={onExport}
        className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-blue-500 text-white rounded-sm px-5 py-2.5 text-sm font-semibold transition-colors"
      >
        <Download className="h-4 w-4" /> Export CSV
      </button>
      <button
        data-testid="admin-logout-button"
        onClick={onLogout}
        className="inline-flex items-center justify-center gap-2 border border-zinc-800 text-zinc-400 hover:text-white rounded-sm px-4 py-2.5 text-sm font-medium transition-colors"
      >
        <LogOut className="h-4 w-4" /> Sign Out
      </button>
    </div>
  </div>
);
